module.exports = __webpack_public_path__ + "media/images/loop-21265aa900523367f4ad735ebf51b744.svg";